import * as moment from "moment";

export function formatDateTime(datetime?: Date | string | null | undefined) {
  if (datetime) {
    return moment(datetime, 'YYYY-MM-DDTHH:mm:ss').format('MMM YY, hh:mm A');
  }

  return null;
}
